var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarSedan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9688 20.3271H8.59375",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 18.9521H2.40625",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 18.9521H1.03125",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 16.8896H13.0625",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 16.8896H19.5938C20.3363 16.8896 20.9413 16.2984 20.9688 15.5628C20.9413 13.6446 19.7794 11.9259 18.0056 11.1903L17.7788 11.094C17.1662 10.8328 16.6231 10.434 16.1968 9.92527L15.8806 9.54715C14.3138 7.6634 11.99 6.57715 9.5425 6.57715H7.73438C6.12563 6.57715 4.62 7.38152 3.72625 8.72215L3.47188 9.10027C3.22506 9.4784 2.90125 9.80152 2.52313 10.049L1.64313 10.6403C1.25813 10.8946 1.03125 11.3209 1.03125 11.7815V15.5146C1.03125 16.141 1.45544 16.6731 2.03087 16.8374",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96877 10.7021H17.0706C16.7475 10.4821 16.445 10.2278 16.1968 9.92527L15.8806 9.54715C14.3138 7.6634 11.99 6.57715 9.54252 6.57715H7.73439C6.73064 6.57715 5.76814 6.8934 4.97064 7.45027",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41748 8.63965L5.52061 8.91465C5.91936 9.99402 6.94304 10.7021 8.09117 10.7021H8.59304",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 16.8896C7.21875 18.0309 6.2975 18.9521 5.15625 18.9521C4.015 18.9521 3.09375 18.0309 3.09375 16.8896C3.09375 15.7484 4.015 14.8271 5.15625 14.8271C6.2975 14.8271 7.21875 15.7484 7.21875 16.8896Z",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 17.5771C5.53595 17.5771 5.84375 17.2693 5.84375 16.8896C5.84375 16.51 5.53595 16.2021 5.15625 16.2021C4.77655 16.2021 4.46875 16.51 4.46875 16.8896C4.46875 17.2693 4.77655 17.5771 5.15625 17.5771Z",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 16.8896C18.2188 18.0309 17.2975 18.9521 16.1562 18.9521C15.015 18.9521 14.0938 18.0309 14.0938 16.8896C14.0938 15.7484 15.015 14.8271 16.1562 14.8271C17.2975 14.8271 18.2188 15.7484 18.2188 16.8896Z",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 17.5771C16.5359 17.5771 16.8438 17.2693 16.8438 16.8896C16.8438 16.51 16.5359 16.2021 16.1562 16.2021C15.7766 16.2021 15.4688 16.51 15.4688 16.8896C15.4688 17.2693 15.7766 17.5771 16.1562 17.5771Z",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 10.7021H9.96875L9.625 7.6084",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0063 12.7646H17.875L17.9575 13.1015C18.1088 13.7134 18.6587 14.1396 19.2906 14.1396H19.6969",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34919 12.7646H1.03125",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9117 15.5146H19.5938",
    stroke: "#CE931A",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSedan);
export default __webpack_public_path__ + "static/media/car-sedan.6cdb1e2f6cd3f50692e5885b19baac41.svg";
export { ForwardRef as ReactComponent };